<form #challanForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/challan']">Challan</a> > {{ challan.challan_no }}</h3>
    </div>
    <div class="form-actions">
      <a *ngIf="challan.id && isFormDisabled && !['cancelled'].includes(challan.status)" target="_blank" href="/api/challan/{{ challan.id }}/download">
        <button type="button" mat-stroked-button><mat-icon>print</mat-icon> Print</button>
      </a>
      <ng-container *ngIf="!['submitted','cancelled'].includes(challan.status)">
        <button *ngIf="isFormDisabled && challan.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog(challan.id, 'submit')">
          <mat-icon>check_circle</mat-icon> Submit
        </button>
        <button *ngIf="isFormDisabled && challan.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="confirmDialog(challan.id, 'cancel')">Cancel</button>
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(challanForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Create
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Challan No</mat-label>
            <input #challan_no="ngModel" [disabled]="true" type="text" matInput name="challan_number" [(ngModel)]="challan.challan_no">
            <mat-error *ngIf="challan_no.invalid && challan_no.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Challan Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="challan.challan_date" name="job_date" [matDatepicker]="challan_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="challan_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #challan_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" (selectionChange)="onDoctorChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Job Type</mat-label>
            <mat-select [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedJobType" (selectionChange)="onDoctorChange()">
              <input class="select-input" type="text" autocomplete="nope" matInput name="job_type">
              <mat-option *ngFor="let jobType of allJobTypes" [value]="jobType">{{ jobType | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Shipment Type</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedShips">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onShipKey($event)" matInput name="ship_list">
              <mat-option *ngFor="let ship of filteredShips" [value]="ship.id">{{ ship.type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Remark</mat-label>
            <textarea rows="2" matInput name="remark" [(ngModel)]="challan.remark"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="selectedDoctor">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Select Job(s)</mat-label>
            <mat-chip-grid class="matChipClasscross" #chipList aria-label="Job selection">
              <mat-chip-row class="matChipClass" *ngFor="let job of selectedJobChips" [removable]="removable" (removed)="remove(job)">
                {{ job }}
                <button matChipRemove *ngIf="removable"><mat-icon>cancel</mat-icon></button>
              </mat-chip-row>
              <input #chipInput onkeydown="return false;" [formControl]="jobCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let job of filteredJobs" [value]="job">{{ job.job_no }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <!-- Line Items Table -->
      <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z2 mt-3">
        <ng-container matColumnDef="job_no">
          <th mat-header-cell *matHeaderCellDef>Job No.</th>
          <td mat-cell *matCellDef="let element">{{ element.job_no }}</td>
        </ng-container>
        <ng-container matColumnDef="job_date">
          <th mat-header-cell *matHeaderCellDef>Job Date</th>
          <td mat-cell *matCellDef="let element">{{ this.transformDate(element.job_date) }}</td>
        </ng-container>
        <ng-container matColumnDef="patient_name">
          <th mat-header-cell *matHeaderCellDef>Patient Name</th>
          <td mat-cell *matCellDef="let element">{{ element.patient_name }}</td>
        </ng-container>
        <ng-container matColumnDef="product_name">
          <th mat-header-cell *matHeaderCellDef>Product Name</th>
          <td mat-cell *matCellDef="let element">{{ element.product_name }}</td>
        </ng-container>
        <ng-container matColumnDef="product_units">
          <th mat-header-cell *matHeaderCellDef>Units</th>
          <td mat-cell *matCellDef="let element">{{ element.product_units }}</td>
        </ng-container>
        <ng-container matColumnDef="product_rate">
          <th mat-header-cell *matHeaderCellDef>Rate</th>
          <td mat-cell *matCellDef="let element">{{ element.rate | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="amount_total">
          <th mat-header-cell *matHeaderCellDef>Total Amount</th>
          <td mat-cell *matCellDef="let element">{{ element.amount_total | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </fieldset>
  </div>
  <app-audit-log-viewer model="challan" [recordId]="challan.id"></app-audit-log-viewer>
</form>
